const URL_RE = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi
const TRAILING = /[.,;:!?)\]}'"]$/

export type LinkPart = { text: string; href?: string }

/** Splits plain text into text and http(s) link parts; joining the parts' text gives the input back. */
export function splitLinks(input: string): LinkPart[] {
  const parts: LinkPart[] = []
  let last = 0
  for (const m of input.matchAll(URL_RE)) {
    let url = m[0]
    // Peel trailing punctuation, but keep a ")" that closes a "(" inside the URL.
    while (TRAILING.test(url)) {
      if (url.endsWith(')') && (url.match(/\(/g)?.length ?? 0) >= (url.match(/\)/g)?.length ?? 0)) {
        break
      }
      url = url.slice(0, -1)
    }
    if (!/^(?:https?:\/\/|www\.)[^\s]+/i.test(url) || /^(?:https?:\/\/|www\.)$/i.test(url)) continue
    const start = m.index ?? 0
    if (start > last) parts.push({ text: input.slice(last, start) })
    parts.push({ text: url, href: /^https?:\/\//i.test(url) ? url : `https://${url}` })
    last = start + url.length
  }
  if (last < input.length) parts.push({ text: input.slice(last) })
  return parts
}

/** Plain text with any web addresses in it made clickable; opens in a new tab (t1290). */
export function LinkifiedText({ text }: { text: string }) {
  return (
    <>
      {splitLinks(text).map((part, i) =>
        part.href ? (
          <a
            // biome-ignore lint/suspicious/noArrayIndexKey: parts are positional and never reorder
            key={i}
            href={part.href}
            target="_blank"
            rel="noopener noreferrer"
            className="break-all text-primary underline hover:no-underline"
          >
            {part.text}
          </a>
        ) : (
          part.text
        ),
      )}
    </>
  )
}
